/**
 * Add days to given date
 * @param date - a Date
 * @param days - a number of days
 */
export default (date, days) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
};
